export default __webpack_public_path__ + "static/media/icon_comment.71ca64ef.svg";